export default function getIdFromSelfLink(dbEntity) {
  // eslint-disable-next-line no-underscore-dangle
  const source = dbEntity?._links?.self?.href?.split('/');
  const primaryKey = source[source.length - 1];

  return primaryKey;
}
